module.exports = __webpack_public_path__ + "img/forgot-password.5dd666b3.png";